import { z } from "zod";
import { BaseEvent } from "./base";
export const Cront_Start = BaseEvent.extend({
    name: z.literal("events.superwall.com.ops.v1.Cron_Start"),
    event: z.object({
        cron_id: z.string(),
        name: z.string()
    })
});
export const Cron_Heartbeat = BaseEvent.extend({
    name: z.literal("events.superwall.com.ops.v1.Cron_Heartbeat"),
    event: z.object({
        cron_id: z.string(),
        name: z.string()
    })
});
export const Cron_Complete = BaseEvent.extend({
    name: z.literal("events.superwall.com.ops.v1.Cron_Complete"),
    event: z.object({
        cron_id: z.string(),
        name: z.string()
    })
});
export const Cron_Fail = BaseEvent.extend({
    name: z.literal("events.superwall.com.ops.v1.Cron_Fail"),
    event: z.object({
        cron_id: z.string(),
        name: z.string(),
        error: z.string()
    })
});
